/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Thanks/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Thanks({
  children,
  viewPath = "/App/Widget/Content/Questions/GreyfinchComplete/Thanks"
  
}) {
let widgetHasBookingValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'hasBooking',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 size="large"
 text={widgetHasBookingValueData ? "We can't wait to see you! If you scheduled a virtual visit you will receive a link via email and/or SMS for your virtual call." : "Thanks for your interest. Someone will be in touch soon to answer your questions."}
 hyphens="none"
 data="widget.hasBooking"
/>
{children}
</React.Fragment>)
}